"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = createPortal;

var _react = require("react");

var _context = _interopRequireDefault(require("@sift/skipper/components/PortalProvider/context"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _shortid = _interopRequireDefault(require("shortid"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function createPortal(name) {
  var portalId = (0, _shortid["default"])();

  function Portal(_ref) {
    var children = _ref.children;
    var portalContext = (0, _react.useContext)(_context["default"]);

    if (!portalContext) {
      throw new Error("[".concat(name, "Portal] could not find portal context"));
    }

    var contentEls = portalContext.contentEls;
    var contentEl = contentEls[portalId];

    if (!contentEl) {
      return null;
    }

    return /*#__PURE__*/_reactDom["default"].createPortal(children, contentEl);
  }

  Portal.displayName = "".concat(name, "Portal");
  Object.defineProperty(Portal, '__portalId', {
    get: function get() {
      return portalId;
    }
  });
  var PortalFixedTypings = Portal;
  return PortalFixedTypings;
}